import { DRAW_DENOMINATION, ILang } from '@libs/interfaces';
export const space = ' ';
export const LANGS: ILang[] = [
  {
    code: 'es',
    desc: 'Español',
  },
  {
    code: 'pt',
    desc: 'Português',
    default: true,
  },
  {
    code: 'en',
    desc: 'English',
  },
];
export const FIRST_TIMESTAMP_USERS = 1617000413179;

export const MS_ONE_MIN = 1000 * 60;
export const MS_ONE_HOUR = MS_ONE_MIN * 60;
export const MS_24_HOURS = MS_ONE_HOUR * 24;
export const MS_12_HOURS = MS_ONE_HOUR * 12;
export const TIME_TO_REFRESH = MS_ONE_MIN * 20;
export const TRACKING_INTERVAL = 3000;
export const ONE_DAY_MILISECONDS = 24 * 60 * 60 * 1000;
export const VIEW_DESKTOP_LIMIT = 920;
export const VIEW_MOBILE_LIMIT = 575;
export const VIEW_MOBILE_SMALL_LIMIT = 340;

export const DAYS_WEEK = [
  { pt: 'Domingo', en: 'Sunday', es: 'Domingo' },
  { pt: 'Segunda-feira', en: 'Monday', es: 'Lunes' },
  { pt: 'Terça-feira', en: 'Tuesday', es: 'Martes' },
  { pt: 'Quarta-feira', en: 'Wednesday', es: 'Miercoles' },
  { pt: 'Quinta-feira', en: 'Thursday', es: 'Jueves' },
  { pt: 'Sexta-feira', en: 'Friday', es: 'Viernes' },
  { pt: 'Sabado', en: 'Sutarday', es: 'Sabado' },
];
export const MapDrawDenomination = (denom: DRAW_DENOMINATION) =>
  ['PPT', 'PTM', 'PT', 'PTV', 'PTN', 'COR', 'FED'][denom];
export const Meses = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];
export const ASCCI_HIDDEN = String.fromCharCode(160);
